import React from "react";
import PemilihCari from "./PemilihCari";
import { cariCustomer, labelCustomer, ketCustomer } from "../../lib/sumberPilihan";

// Pemilih customer — sejak 27 Sep 2026 cuma pembungkus tipis `PemilihCari`
// (pola daftar seragam, `docs/POLA_DAFTAR.md`). Bentuk props dan data-testid
// DIPERTAHANKAN supaya pemakai lama (FaLama) tidak berubah.
// Props: value (objek customer atau null), onChange(customer), disabled
export default function CustomerSearchSelect({ value, onChange, disabled, testId = "customer-search-select" }) {
  return (
    <PemilihCari
      value={value}
      onChange={onChange}
      disabled={disabled}
      testId={testId}
      cari={cariCustomer}
      label={labelCustomer}
      keterangan={ketCustomer}
      placeholder="Pilih customer..."
      placeholderCari="Cari nama atau no. telepon..."
      tampilAwal
    />
  );
}
